export default __webpack_public_path__ + "static/media/Selected_Skipping_Rope.13c1c8d5.svg";